module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(!_vm.isAuthenticated) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.authenticate()
      }
    }
  }, [_vm._v("Увійти")]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.signout()
      }
    }
  }, [_vm._v("Вийти з аккаунта")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28082acb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 616
// module chunks = 1